<template>
  <div
    :style="{ 'height': `${data.Size}px` }"
  />
</template>

<script>
  export default {
    props: {
      data: {
        type: Object,
        required: true,
        default: null
      },
    },
  }
</script>
